export const supportStatuses = {
  Open: "Open",
  Closed: "Closed",
} as const;

export const supportTypes = {
  Chat: "Chat",
  Email: "Email",
} as const;

export const supportPriorities = {
  Low: "Low",
  Medium: "Medium",
  High: "High",
} as const;

export type SupportType = keyof typeof supportTypes;
export type SupportStatusType = keyof typeof supportStatuses;
export type SupportPriorityType = keyof typeof supportPriorities;

export type MessageType = {
  id: string;
  title: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar?: string;
  company: string;
  selected: boolean;
  markedAsRead: boolean;
  summary: string;
  description: string;
  date: Date;
  hasAttachments: boolean;
  category: string;
  supportType: SupportType;
  status: SupportStatusType;
  priority: SupportPriorityType;
  username: string;
  attachments: {
    id: string;
    type: string;
    name: string;
    size: string;
    thumbnail: string;
    preview: string;
  }[];
};

export const messages = [
  {
    id: "0239847207",
    selected: false,
    title: "Practical Cotton Chips",
    firstName: "عرفان",
    lastName: "ابراهیمی",
    email: "Laura83@yahoo.com",
    avatar:
      "https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-12.webp",
    company: "Torp Inc",
    markedAsRead: false,
    summary:
      "ارائه شکل و کارکرد گرافیکی به صورت موقت استفاده می‌نماید تا کمک کند که صفحه‌آرایی یا ارائه به نظر خوب و روشن باشد.",
    description:
      "لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک از این نوع متن برای ارائه شکل و کارکرد گرافیکی به صورت موقت استفاده می‌نماید تا کمک کند که صفحه‌آرایی یا ارائه به نظر خوب و روشن باشد. متن لورم ایپسوم در حقیقت بخشی از آثار لاتین کلاسیک و ناشناخته از قرن پنجم بعد از میلاد است.",
    date: new Date("2022-11-28T23:39:07.359Z"),
    category: "all-open",
    hasAttachments: true,
    status: supportStatuses.Closed as SupportStatusType,
    supportType: supportTypes.Chat,
    priority: supportPriorities.Medium,
    username: "kadf",
    attachments: [
      {
        id: "72854",
        type: "image",
        name: "afore_how_strike.jpg",
        size: "2.2mb",
        thumbnail: "https://picsum.photos/seed/0cxiM/128/128",
        preview: "https://loremflickr.com/640/480/nature?lock=5038006564028416",
      },
      {
        id: "50000",
        type: "pdf",
        name: "gravel_dispel_impish.pdf",
        size: "1.3mb",
        thumbnail: "https://picsum.photos/seed/6f8nBDZJ/128/128",
        preview: "https://loremflickr.com/640/480/nature?lock=545556797587456",
      },
    ],
  },
];
